module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-page"
  }, [_c('page-head', {
    staticClass: "page-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('left-bar-single'), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('loading')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5054157e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/single_home.vue
// module id = 795
// module chunks = 1